import { useRestApiProvider } from "@jugl-web/rest-api";
import { TaskBoardModel } from "@jugl-web/rest-api/tasks/models/TaskBoard";
import { useCallback, useMemo } from "react";

interface UseTaskBoardsQueryOptions {
  entityId: string;
}

export const useTaskBoardsQuery = ({ entityId }: UseTaskBoardsQueryOptions) => {
  const { tasksApi } = useRestApiProvider();

  const { data, isLoading, isFetching, isError, refetch } =
    tasksApi.useGetUserTaskBoardsQuery({
      entityId,
    });

  const cachedBoards = useMemo(() => data || [], [data]);

  const cachedBoardsMap = useMemo<Map<string, TaskBoardModel>>(
    () => new Map(cachedBoards.map((board) => [board.id, board])),
    [cachedBoards]
  );

  const getBoardByIdFromCache = useCallback(
    (boardId: string) => cachedBoardsMap.get(boardId),
    [cachedBoardsMap]
  );

  const getBoardByNameFromCache = useCallback(
    (name: string) => cachedBoards.find((board) => board.name === name),
    [cachedBoards]
  );

  return {
    cachedBoards,
    isLoading,
    isFetching,
    isError,
    refetch,
    getBoardByIdFromCache,
    getBoardByNameFromCache,
  };
};
